var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.58 0L0 3.01L10.06 12L0 20.99L2.58 24L16 12L2.58 0Z"}));
}

ChevronRight.defaultProps = {"width":"16","height":"24","viewBox":"0 0 16 24","fill":"currentColor"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
